module.exports = __webpack_public_path__ + "img/David Mihal.896a8672.jpg";